import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { translations } from './translations'
import Contact from './Contact.vue'
import Home from './Home.vue'
import Skills from './Skills.vue'

Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.config.productionTip = false

const routes= [
    {
      path: '/',
      redirect: {name: 'home', params: { language: 'en' }}
    },
    {
      path: '/:language',
      name: 'home',
      component: Home,
    },
    {
      path: '/contact/:language',
      name: 'contact',
      component: Contact
    },
    {
      path: '/skills/:language',
      name: 'skills',
      component: Skills
    }
  ]

const router = new VueRouter({
  routes, // short for `routes: routes`

})

localStorage.setItem("language", 'en');

const i18n = new VueI18n({
  locale: localStorage.language,
  messages: translations // set locale messages
})

router.beforeEach((to, from, next) => {
  i18n.locale = to.params.language;
  next();

});

new Vue({
  i18n,
  router,
  el: '#app',
  render: h => h(App)
})
